import client from "../utils/ApiHelper.js";
import ErrorException from "../utils/Exceptions.js";

async function fetchAllDepartement() {
    try {
        let res = await client.get("/department");

        return res.data;
    } catch (err) {
        throw ErrorException(err);
    }
}

async function fetchOneDepartement(id) {
    try {
        let res = await client.get("/department/department_id/" + id);

        return res.data;
    } catch (err) {
        throw ErrorException(err);
    }
}

async function createDepartement(name) {
    try {
        let res = await client.post("/department/create", {
            name: name
        });

        return res.data;
    } catch (err) {
        throw ErrorException(err);
    }
}

async function updateDepartement(id, name) {
    try {
        let res = await client.post("/department/update", {
            id: id,
            name: name
        });

        return res.data;
    } catch (err) {
        throw ErrorException(err);
    }
}

async function importDepartement(file) {
    const form = new FormData();
    form.append("file", file);

    const config = {
        headers: {
            'content-type': 'multipart/form-data'
        }
    }

    try {
        let res = await client.post("/department/upload", form, config);

        return res.data;
    } catch (err) {
        throw ErrorException(err);
    }
}

async function deleteDepartement(id) {
    try {
        let res = await client.delete("/department/department_id/" + id);

        return res.data;
    } catch (err) {
        throw ErrorException(err);
    }
}

export {
    fetchAllDepartement,
    fetchOneDepartement,
    createDepartement,
    updateDepartement,
    importDepartement,
    deleteDepartement,
};
